package ui.widget


import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.LocalTime
import ssoft.frontend.generated.resources.Res
import ssoft.frontend.generated.resources.dialog__action_cancel
import ssoft.frontend.generated.resources.dialog__action_ok
import tools.EFieldRegularDateTime
import tools.EFieldRegularTime
import tools.rememberString


@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun TimePickerDialog(state: DialogState, field: EFieldRegularTime) {
    Dialog(state) {

        val pickerState = remember {
            TimePickerState(
                initialHour = field.state.hour,
                initialMinute = field.state.minute,
                is24Hour = true
            )
        }
        DialogUI(
            Modifier.align(Alignment.Center),
            onDismissRequest = { state.hide() },
            dismissButton = {
                TextButton({ state.hide() }) {
                    Text(Res.string.dialog__action_cancel.rememberString())
                }
            },
            confirmButton = {
                TextButton({
                    field.set(LocalTime(pickerState.hour, pickerState.minute))
                    state.hide()
                }) {
                    Text(Res.string.dialog__action_ok.rememberString())

                }
            }) {
            TimePicker(
                state = pickerState,
                layoutType = TimePickerLayoutType.Vertical
            )
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun TimePickerDialog(state: DialogState, field: EFieldRegularDateTime) {
    Dialog(state) {

        val pickerState = remember(field.state) {
            TimePickerState(
                initialHour = field.state.hour,
                initialMinute = field.state.minute,
                is24Hour = true
            )
        }
        DialogUI(
            Modifier.align(Alignment.Center),
            onDismissRequest = { state.hide() },
            dismissButton = {
                TextButton({ state.hide() }) {
                    Text(Res.string.dialog__action_cancel.rememberString())
                }
            },
            confirmButton = {
                TextButton({
                    val newTime = LocalTime(pickerState.hour, pickerState.minute)
                    field.set(LocalDateTime(field.state.date, newTime))
                    state.hide()
                }) {
                    Text(Res.string.dialog__action_ok.rememberString())

                }
            }) {
            TimePicker(
                state = pickerState,
                layoutType = TimePickerLayoutType.Vertical
            )
        }
    }
}

